import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class Fir5471ScheduleMService {

  constructor(private http: HttpClient) { }

  saveScheduleM(
    baseUrl: string,
    scheduleSettings: any[],
    scheduleDetails: any,
    globalParams: any = {},
    filterParams: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=p5vfbm`;

    let params: any = _.merge({}, globalParams, filterParams);
    params = _.extend({jsonObj: JSON.stringify(scheduleDetails)}, params);
    params = _.extend({jsonSettings: JSON.stringify(scheduleSettings)}, params);
    params.process_name = "Schedule_M_Save";

    return this.http.post<any>(url, params, { withCredentials: true });
  }
}
